import React, { Component } from 'react';

import "@material/react-chips/dist/chips.css";
import NavBar from '../../shared/NavBar';
import {Col, Row, Button, Input, Badge, InputGroup, InputGroupAddon, ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText, Jumbotron, Card, CardHeader, CardBody} from 'reactstrap';

import {connect} from "react-redux";

import './TestUsers.css';

class TestUsers extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            searchSales: '',
            listSalesResults: [],
            devUserSales: {},
            showSearchSales: false,

            searchSetter: '',
            listSetterResults: [],
            devUserSetter: {},
            showSearchSetter: false,

            searchCustomer: '',
            listCustomerResults: [],
            devUserCustomer: {},
            showSearchCustomer: false,

            searchField: '',
            listFieldResults: [],
            devUserField: {},
            showSearchField: false,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.capital = this.capital.bind(this);

        this.handleSearch = this.handleSearch.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.selectUserTest = this.selectUserTest.bind(this);
        
        
    }

    componentDidMount() {
        this.getDevUsers();
    }


    capital(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
    
        this.setState({
          [name]: value
        });
    }

    clearSearch(app){
        app = this.capital(app);
        var r = "list"+app+"Results";
        var s = "search"+app;

        this.setState({
            [r]: [],
            [s]: ''
        });
    }

    getDevUsers(){
        this.fetchDevUser("devUserSales", "sales");
        this.fetchDevUser("devUserSetter", "setter");
        this.fetchDevUser("devUserCustomer", "customer");
        this.fetchDevUser("devUserField", "field");
    }

    fetchDevUser(prop, app){
        fetch('https://api.iondeveloper.com/admin/settings/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "getDevUser",
                    "app": app
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {


            if (data.success){
                this.setState({
                    [prop]: data.data
                }, ()=> {
                    
                });
            }

        }.bind(this));
    }

    handleSearch(app){

        var cap = this.capital(app);
        var x = "showSearch"+cap;
        this.setState({
            [x]: true,
            ["list"+cap+"Results"]: []
        }, ()=> {
            let searchVal = "";
            let propList = "";
            if(app == "sales"){
                searchVal = this.state.searchSales;
                propList = "listSalesResults";
            } else if(app == "setter"){
                searchVal = this.state.searchSetter;
                propList = "listSetterResults";
            } else if(app == "customer"){
                searchVal = this.state.searchCustomer;
                propList = "listCustomerResults";
            } else if(app == "field"){
                searchVal = this.state.searchField;
                propList = "listFieldResults";
            }

            if(searchVal == "" || searchVal == " ") return;
            fetch('https://api.iondeveloper.com/admin/settings/', {
                method: 'post',
                body: JSON.stringify(
                    {
                        "method": "searchActiveUsers",
                        "app": app,
                        "search": searchVal
                    }
                )
            }).then(function(response) {
                return response.json();
            }).then(function(data) {


                if (data.success){
                    this.setState({
                        [propList]: data.data,
                        [x]: false
                    }, ()=> {
                        
                    });
                }

            }.bind(this));
        });
    }

    selectUserTest(id, app){

        fetch('https://api.iondeveloper.com/admin/settings/', {
            method: 'post',
            body: JSON.stringify(
                {
                    "method": "updateDevUser",
                    "app": app,
                    "id": id
                }
            )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {
            if (data.success){
                alert("Test User updated successfully!");
                this.clearSearch(app);
                this.fetchDevUser("devUser"+this.capital(app), app);
            }

        }.bind(this));
    }

    /*** SETTER ***/


    
    render() {
        const { showSearchSales, showSearchSetter, showSearchField, showSearchCustomer } = this.state;

        return (
            <div>
                <NavBar />
                <div className="container">
                    <div className="email-container">
                        <h4><b>Sales App</b> </h4>
                        <Jumbotron>
                            <h4>Dev User &#8594; {this.state.devUserSales.name}</h4>
                            <hr />
                            <p>To update the test user, search the name and select a rep from the list.</p>
                            <InputGroup>
                                <Input type="text" placeholder="Search Active Rep" name="searchSales" value={this.state.searchSales} onChange={this.handleInputChange} />
                                <InputGroupAddon addontype="append">
                                    <Button color="light" onClick={()=>this.clearSearch("sales")}>Clear</Button>
                                    <Button color="dark" onClick={()=>this.handleSearch("sales")}>Search</Button>
                                </InputGroupAddon>
                            </InputGroup>
                            {showSearchSales && (<p className="search-p">Searching . . .</p>)}

                            <ListGroup>
                            {this.state.listSalesResults.map((item, i) =>
                                (<ListGroupItem key={i} tag="button" action onClick={()=>this.selectUserTest(item.id, "sales")}>
                                    <ListGroupItemHeading>{item.name}</ListGroupItemHeading>
                                    <ListGroupItemText>{item.email}</ListGroupItemText>
                                </ListGroupItem>)
                            )}
                                {/* {repSearchResult} */}
                            </ListGroup>
                        </Jumbotron>
                    </div>
                </div>

                <div className="container">
                    <div className="email-container">
                        <h4><b>Sunsetter App</b> </h4>
                        <Jumbotron>
                            <h4>Dev User &#8594; {this.state.devUserSetter.name}</h4>
                            <hr />
                            <p>To update the test user, search the name and select a rep from the list.</p>
                            <InputGroup>
                                <Input type="text" placeholder="Search Setter" name="searchSetter" value={this.state.searchSetter} onChange={this.handleInputChange} />
                                <InputGroupAddon addontype="append">
                                    <Button color="light" onClick={()=>this.clearSearch("setter")}>Clear</Button>
                                    <Button color="dark" onClick={()=>this.handleSearch("setter")}>Search</Button>
                                </InputGroupAddon>
                            </InputGroup>
                            {showSearchSetter && (<p className="search-p">Searching . . .</p>)}

                            <ListGroup>
                            {this.state.listSetterResults.map((item, i) =>
                                (<ListGroupItem key={i} tag="button" action onClick={()=>this.selectUserTest(item.id, "setter")}>
                                    <ListGroupItemHeading>{item.name}</ListGroupItemHeading>
                                    <ListGroupItemText>{item.email}</ListGroupItemText>
                                </ListGroupItem>)
                            )}
                                {/* {repSearchResult} */}
                            </ListGroup>
                        </Jumbotron>
                    </div>
                </div>

                <div className="container">
                    <div className="email-container">
                        <h4><b>FieldPro App</b> </h4>
                        <Jumbotron>
                            <h4>Dev User &#8594; {this.state.devUserField.name}</h4>
                            <hr />
                            <p>To update the test user, search the name and select a rep from the list.</p>
                            <InputGroup>
                                <Input type="text" placeholder="Search FieldPro" name="searchField" value={this.state.searchField} onChange={this.handleInputChange} />
                                <InputGroupAddon addontype="append">
                                    <Button color="light" onClick={()=>this.clearSearch("field")}>Clear</Button>
                                    <Button color="dark" onClick={()=>this.handleSearch("field")}>Search</Button>
                                </InputGroupAddon>
                            </InputGroup>
                            {showSearchField && (<p className="search-p">Searching . . .</p>)}

                            <ListGroup>
                            {this.state.listFieldResults.map((item, i) =>
                                (<ListGroupItem key={i} tag="button" action onClick={()=>this.selectUserTest(item.id, "field")}>
                                    <ListGroupItemHeading>{item.name}</ListGroupItemHeading>
                                    <ListGroupItemText>{item.email}</ListGroupItemText>
                                </ListGroupItem>)
                            )}
                                {/* {repSearchResult} */}
                            </ListGroup>
                        </Jumbotron>
                    </div>
                </div>

                <div className="container">
                    <div className="email-container">
                        <h4><b>Customer App</b> </h4>
                        <Jumbotron>
                            <h4>Dev User &#8594; {this.state.devUserCustomer.name}</h4>
                            <hr />
                            <p>To update the test user, search the name and select a rep from the list.</p>
                            <InputGroup>
                                <Input type="text" placeholder="Search Customer" name="searchCustomer" value={this.state.searchCustomer} onChange={this.handleInputChange} />
                                <InputGroupAddon addontype="append">
                                    <Button color="light" onClick={()=>this.clearSearch("customer")}>Clear</Button>
                                    <Button color="dark" onClick={()=>this.handleSearch("customer")}>Search</Button>
                                </InputGroupAddon>
                            </InputGroup>
                            {showSearchCustomer && (<p className="search-p">Searching . . .</p>)}

                            <ListGroup>
                            {this.state.listCustomerResults.map((item, i) =>
                                (<ListGroupItem key={i} tag="button" action onClick={()=>this.selectUserTest(item.id, "customer")}>
                                    <ListGroupItemHeading>{item.name}</ListGroupItemHeading>
                                    <ListGroupItemText>{item.email}</ListGroupItemText>
                                </ListGroupItem>)
                            )}
                                {/* {repSearchResult} */}
                            </ListGroup>
                        </Jumbotron>
                    </div>
                </div>

                

            </div>
        );
    }

}

function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(TestUsers);


// WEBPACK FOOTER //
// ./src/components/pages/TestUsers/TestUsers.js